import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { GridColumn, GridContainer, GridRow } from './GridContainer';
const DebugContainer = styled.div`
  display: none;
  height: 0;
  pointer-events: none;
  position: sticky;
  top: 0;
  z-index: 998;

  #grid-toggle:checked ~ & {
    display: block;
  }

  span {
    background: rgba(255, 0, 0, 0.1);
    color: #333;
    display: block;
    height: 100vh;
  }
`;
const GridToggle = styled.input`
  opacity: 0;
  position: absolute;
  visibility: hidden;
`;
const Toolbar = styled.div`
  background-color: #fcbc67;
  border-radius: 0 0 0.5rem 0.5rem;
  display: flex;
  left: 0;
  opacity: 0.5;
  padding: 0.25rem 0.5rem 0.5rem;
  position: fixed;
  top: 50%;
  transform: rotate(-90deg) translate(-50%, calc(-100% + 0.5rem));
  transform-origin: 0 0;
  transition:
    opacity 0.25s ease-out,
    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9999;

  &:hover {
    opacity: 1;
    transform: rotate(-90deg) translate(-50%, 0);
  }
`;
const toolbarLinkStyles = css`
  border-right: 2px solid #000;
  cursor: pointer;
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0 0.5rem;

  &:last-child {
    border-right: none;
  }
`;
const ToolbarLink = styled.a`
  ${toolbarLinkStyles}

  &[target='_blank'] span::after {
    content: '\\2197';
  }
`;
const ToolbarLabel = styled.label`
  ${toolbarLinkStyles}
`;
export const GridDebugger = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(GridToggle, {
                "aria-label": "Grid anzeigen",
                id: "grid-toggle",
                type: "checkbox"
            }),
            /*#__PURE__*/ _jsxs(Toolbar, {
                id: "grid-toolbar",
                children: [
                    /*#__PURE__*/ _jsx(ToolbarLink, {
                        href: "https://lichtblick-next-storybook.netlify.app/",
                        target: "_blank",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: "Storybook"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ToolbarLink, {
                        href: "https://lichtblick-email.netlify.app/",
                        target: "_blank",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: "Email templates"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ToolbarLink, {
                        href: "https://graphdev.lichtblick.de/",
                        target: "_blank",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: "GraphQL Playground"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ToolbarLabel, {
                        htmlFor: "grid-toggle",
                        children: /*#__PURE__*/ _jsx("span", {
                            children: "Toggle grid"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DebugContainer, {
                id: "grid-debugger",
                children: /*#__PURE__*/ _jsx(GridContainer, {
                    children: /*#__PURE__*/ _jsxs(GridRow, {
                        children: [
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            }),
                            /*#__PURE__*/ _jsx(GridColumn, {
                                $width: 1,
                                children: /*#__PURE__*/ _jsx("span", {})
                            })
                        ]
                    })
                })
            })
        ]
    });

//# sourceMappingURL=GridDebugger.js.map